module.exports = __webpack_public_path__ + "static/img/pic01.27a81ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/images/pic01.jpg
// module id = XMeW
// module chunks = 2